import React from 'react';
import { ClipLoader } from 'react-spinners';

import { Link } from 'react-router-dom';

/**
 * @param {{
 *   text: string,
 *   url?: string,
 *   callback?: () => void,
 *   className?: string,
 *   loading?: boolean,
 *   disabled?: boolean,
 *   type?: 'button' | 'submit' ,
 * }} props
 * @returns {JSX.Element}
 */

const Button = ({
  text,
  url,
  callback = () => {},
  className = '',
  type = 'button',
  loading = false,
  disabled = false,
}) => {
  if (url) {
    return (
      <Link
        to={url}
        className={`font-poppins bg-blue-10 text-white hover:scale-105 active:scale-95 transition-all duration-300 font-bold text-xl px-8 py-4 rounded-xl cursor-pointer ${className}`}>
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </Link>
    );
  }
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={callback}
      className={`relative font-poppins bg-blue-10 text-white hover:scale-105 active:scale-95 transition-all duration-300 font-bold text-xl px-8 py-4 rounded-xl cursor-pointer flex flex-row items-center justify-center gap-4 ${className}`}>
      <span
        dangerouslySetInnerHTML={{ __html: text }}
        style={{ opacity: loading ? 0 : 1, zIndex: loading ? -1 : 1 }}
      />
      {loading && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <ClipLoader color="white" size={20} />
        </div>
      )}
    </button>
  );
};

export default Button;
